import { useCallback, useEffect, useMemo, useState } from "react";
import { useParams } from "react-router-dom";

import GenericBody from "../Componentes/GenericBody";
import NavBar from "../Componentes/NavBar";
import Content from "../Modulos/Prossmap/Itens/Content";

const ProssmapItens = () => {
    const [titulo, setTitulo] = useState("PROSSMAP — ITENS");

    const handleProssmapLoaded = useCallback((prossmap) => {
        if (!prossmap) {
            setTitulo("PROSSMAP — ITENS");
            return;
        }

        const mes = prossmap.referencia_mes_label ?? "";
        const nome = prossmap.encarregado_nome ?? "";
        setTitulo(`PROSSMAP — ${nome} — ${mes}`);
    }, []);

    const navbarTitle = useMemo(() => titulo, [titulo]);

    return (
        <>
            <NavBar title={navbarTitle} goBackOnePage />
            <GenericBody>
                <Content onProssmapLoaded={handleProssmapLoaded} />
            </GenericBody>
        </>
    );
};

export default ProssmapItens;
